import { AxiosInstance } from 'axios';
import {
  PlatformResponse,
  PlatformsResponse,
} from 'data/terra/api/terra/response/PlatformResponse';
import { PlatformDescription } from 'data/terra/Platform';
import { result, Result } from 'util/result';
import Terra from '../Terra';

class PlatformEndpoint {
  getPlatformsUrl = () =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/platforms`;
  getPlatformDetailUrl = (platformId: string) =>
    `${Terra.TERRA_HOST}/${Terra.TERRA_BASE_API_URL}/platforms/${platformId}`;
}

export class PlatformApi {
  terraClient: AxiosInstance;
  endpoint = new PlatformEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  fetchPlatforms(): Promise<Result<PlatformsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<PlatformsResponse>(
            this.endpoint.getPlatformsUrl()
          )
        ).data
    );
  }

  addPlatform(data: PlatformDescription): Promise<Result<PlatformResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.post<PlatformResponse>(
            this.endpoint.getPlatformsUrl(),
            data
          )
        ).data
    );
  }
}
